import { participantIdString } from "./conversationDisplay";

/**
 * True when the logged-in agent appears in this visitor conversation’s human participants
 * (they joined / are serving the chat).
 * @param {object | null | undefined} visitor
 * @param {string} [currentUserId] agent _id
 * @returns {boolean}
 */
export function isCurrentAgentServingVisitor(visitor, currentUserId) {
  if (!visitor || !currentUserId) {
    return false;
  }
  const parts = visitor?.current_conversation?.agentParticipants;
  if (!Array.isArray(parts)) {
    return false;
  }
  return parts.some((x) => String(x?._id) === String(currentUserId));
}

/**
 * You were chatting with a visitor that had the brand AI, and you are the only human
 * in the room. Closing/leaving will end the visit for the visitor and archive the
 * conversation — the AI session should end too.
 * @param {object | null | undefined} visitor
 * @param {string} [currentUserId] agent / admin user _id
 * @returns {boolean}
 */
export function shouldConfirmEndEntireSession(visitor, currentUserId) {
  if (!visitor || !currentUserId) {
    return false;
  }
  const convo = visitor?.current_conversation;
  if (!convo) {
    return false;
  }
  const ai = convo.aiAssistant;
  if (!ai) {
    return false;
  }
  const aiId = participantIdString(ai);
  if (!aiId) {
    return false;
  }
  const parts = Array.isArray(convo.agentParticipants) ? convo.agentParticipants : [];
  const humanIds = parts
    .map((p) => participantIdString(p?._id != null ? p : p))
    .filter((id) => id && id !== aiId);
  if (humanIds.length !== 1) {
    return false;
  }
  return String(currentUserId) === humanIds[0];
}
